export default __webpack_public_path__ + "static/media/Vincent-cutout.86d1ab92.png";